const ADD_ALERT = 'ADD_ALERT';
const REMOVE_ALERT = 'REMOVE_ALERT';
const CLEAR_ALERTS = 'CLEAR_ALERT';

export default {
  ADD_ALERT,
  REMOVE_ALERT,
  CLEAR_ALERTS
};